export default {"src":"/_next/static/media/successCircle.2d7b7c4e.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};